<template>
  <div class="serveIndex">
    <div class="kv">
      <Swiper1 v-if="kvList.length > 0" :data="kvList"></Swiper1>
    </div>
    <div class="menus">
      <a :href="`${menu.url ? $Path + menu.url : 'javascript:void(0);' }`" class="menus-item" v-for="(menu, index) in menus" :key="index">
        <img :src="menu.img" alt="" />
        <div class="menu-title">{{ menu.title }}</div>
      </a>
    </div>
    <div class="icons">
      <div
        class="icon-item"
        v-for="(icon, index) in icons"
        :key="'icon' + index"
      >
        <a :href="`${icon.url ? $Path + icon.url : 'javascript:void(0);' }`" class="img">
          <img class="default" :src="icon.img" alt="" />
          <!-- <img class="imghover" :src="icon.imgHover" alt="" /> -->
        </a>
        <div class="title">{{ icon.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { doAdvertiseGeneralList } from "@/api/case.js";
import Swiper1 from "@/components/swiper1";
export default {
  name: "ServeIndex",
  components: {
    Swiper1,
  },
  watch: {},
  data() {
    return {
      kvList: [
        // {
        //   img: require("@/assets/serve/index/serveKV.jpg"),
        //   // url: `${this.$Path}/#/serve/activity`,
        //   url: 'https://mp.weixin.qq.com/s/s5cmsTjMbb-mcvXngw78uQ',
        //   // target: '_top'
        //   target: '_blank'
        // }
        // {
        //   img: require('@/assets/serve/3200_1347.png'),
        //   url: 'https://mp.weixin.qq.com/s?__biz=MzkyMDA1MzAzOQ==&mid=2247495663&idx=1&sn=6836062717dcb4dadb6fe6510bc5e5e7&chksm=c19a1baff6ed92b9fc07b7a71a05fa799acd33d8c9a2b89a7ae3bfb4cf48c3e2be47e95362da&token=1941848510&lang=zh_CN#rd',
        //   target: '_blank'
        // }
      ],
      menus: [
        {
          img: require("@/assets/serve/index/shejizhijia.png"),
          title: "设计之家",
          url: '/#/serve/designer'
        },
        {
          img: require("@/assets/serve/index/jiajuhuanxin.png"),
          title: "家居焕新",
          url: '/#/serve/renew'
        },
        {
          img: require("@/assets/serve/index/xiazai.png"),
          title: "资料下载",
          url: '/#/serve/download'
        },
        {
          img: require("@/assets/serve/index/yuyue.png"),
          title: "定制预约",
          url: '/#/serve/cusAppointment'
        },
        {
          img: require("@/assets/serve/index/changjianwenti.png"),
          title: "常见问题",
          url: '/#/serve/problem'
        },
      ],
      icons: [
        {
          img: require("@/assets/serve/index/mendian-hover.png"),
          title: "门店查询",
          url: '/#/serve/store'
        },
        {
          img: require("@/assets/serve/index/shouquan-hover.png"),
          title: "查授权家具厂",
          url: '/#/serve/factory'
        },
        {
          img: require("@/assets/serve/index/fangwei-hover.png"),
          title: "防伪查询",
          url: '/#/serve/security'
        },
      ],
    };
  },
  created() {
    this.getImageList()
  },
  mounted() {},
  methods: {
    getImageList() {
      doAdvertiseGeneralList({
        adv_sign: 0,
        adv_type: '207',
        adv_state: '-1',
        keyword: '',
        pageNum: 1,
        pageSize: 10
      }).then((res) => {
        if (res.result == 1) {
          this.kvList = res.dataList
        } else {
          this.$message(res.msg)
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.serveIndex {
  max-width: 1920px;
  overflow: hidden;
  margin: 0 auto;
  .kv {
    margin: 38.5px auto;
    overflow: hidden;
  }
  .menus {
    width: 1600px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .menus-item {
      width: 310px;
      height: 178px;
      border-radius: 0 66px 0 66px;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      &:hover {
        img {
          transform: scale(1.05);
        }
      }
      img {
        width: 100%;
        vertical-align: top;
        transition: all 0.3s linear;
      }
      .menu-title {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        font-size: 30px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .icons {
    width: 796px;
    margin: 50px auto;
    display: flex;
    justify-content: space-between;
    .icon-item {
      width: 216px;
      display: flex;
      flex-direction: column;
      position: relative;
      .img {
        width: 100%;
        height: 216px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        position: relative;
        border: 6px solid #fff;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          border-radius: 50%;
          background: rgba(255,255,255,.6);
        }
        .default {
          width: 183px;
          height: 183px;
          vertical-align: middle;
        }
        &:hover {
          border-color: #008C3F;
          &:before {
            display: none;
          }
          .default{
            // transition: all 0.5s linear;
            width: 200px;
            height: 200px;
            opacity: 1;
          }
        }
      }
      .imghover {
        width: 216px;
        height: 216px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        opacity: 0;
        object-fit: contain;
        cursor: pointer;
      }
      .title {
        margin-top: 12.5px;
        text-align: center;
        font-size: 30px;
        font-weight: 400;
        color: #595858;
      }
    }
  }
}
</style>